import Icon from 'components/shared/Icon'

export default function ShareLink ({ shareUrl }: { shareUrl: string }): JSX.Element {
  return (
    <a className='hs8 w8 br2 precedents-blue hover-bg-ghost-white flex justify-center items-center' href={shareUrl} target='_blank' rel='noopener noreferrer'>
      <Icon name='icon-arrow-right' className='hs7 w7' />
    </a>
  )
}
